import { connect } from "react-redux";
import { PacienteViewProps, mapDispatchToPacienteProps, mapStateToPacienteProps } from "../paciente.controller";
import { Paciente } from "../paciente.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { PacienteCadastro } from "./paciente.cad";
import { format } from "@react-input/mask";
 
export const columnsPaciente: GridColDef[] = [
    { field: 'nome', headerName: 'nome', flex: 6 },
    { field: 'whatsapp', headerName: 'Whatsapp', flex: 3, valueGetter:(value,row)=>format(row.whatsapp,{mask:"(__)_ ____-____",replacement:{ _: /\d/ }}) }
]

function PacienteList(props: PacienteViewProps) {
    const { pacienteActions,pacienteState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = pacienteState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = pacienteActions
    console.log("PacienteList props ",props)

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return PacienteCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
            width:"sm"
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Pacientes Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"nome"}
                columns={columnsPaciente}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>read()
                }}
                ListItemTextPrimary={(row: Paciente) => 
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.nome}</Typography>
                        <Typography component={"span"}>{row.whatsapp}</Typography>
                    </Box>
                }
                
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToPacienteProps,mapDispatchToPacienteProps)(PacienteList);
